module.exports = __webpack_public_path__ + "img/kargo.629aa4be.svg";